import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { Link } from "../../lib/Link";

export const voice_case4 = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様インタビュー｜新婚生活の収納場所として'; 
  return (
    <div className="container">
      {breadcrumbs(type, [
        { href: "/voice2/", text: "お客様の声" },
        { text: " 新婚生活の収納場所として。" },
      ])}
      
      <div className="voice_case">
        <h2>活用事例</h2>
        <div className="content">
          <div className="collection">
            <div className="interview_header">
              <div className="title">お客様のご紹介</div>
              <div className="person">
                <span>maomi_ami様</span>
                <br />
                <span>メーカー勤務　29歳　女性</span>
                <br />
                <span>昨年末、ご結婚なさった新婚さん。</span>
              </div>
              <div className="profile">
                <span>
                  無理をしない、程よい抜け感のインテリアがお好きだそうです。
                </span>
                <br />
                <span>
                  最近のマイブームは「ちょっと古いですが重曹＆クエン酸でのお掃除」とのこと♪
                </span>
                <span>笑顔が素敵なエコ派の女性です。</span>
              </div>
            </div>
            <Link to="/tokyo/chuoku/detail/1142/" className="item attention">
              <div className="type star">物件データ</div>
              <div className="title">
                  ハローストレージ月島パート1
              </div>
              <div className="price">
                7,500 /月〜 49,400 /円/月 (0.5帖〜4帖)
              </div>
              <div className="address">東京都中央区月島1丁目26-5</div>
              <div className="transportation">
                都営大江戸線　月島 駅　徒歩 4 分
              </div>
              <div className="image motorbike" />
            </Link>
          </div>
          <div className="h_border" />
          <div className="interview">
            <img src="resource/img/static/voice2/voice_case4/img_1.jpg" />
            <div className="title">新婚生活の収納場所として。</div>
            <div className="question">
              Ｑ：レンタルスペースを使い始めたきっかけは？
            </div>
            <div className="answer">
              <span>
                結婚を機に引越しをしたのですが、気に入った物件の収納がとても少なかったのでトランクルームを使うことにしました。
              </span>
              <br />
              <span>
                最初は収納が多い、もう少し広い部屋も考えたのですが、坪単価で計算するとすごく高くつくことに気づいてやめました。
              </span>
              <br />
              <span>
                だってトランクルームの坪単価と住宅の坪単価、かなり差があるんです！
              </span>
              <br />
              <span>
                新しい引越し先の物件は収納がほぼゼロなので助かっています。
              </span>
            </div>
          </div>
          <div className="interview">
            <img src="resource/img/static/voice2/voice_case4/img_2.jpg" />
            <div className="title">捨てるものの新基準！？</div>
            <div className="question">Ｑ：実際に利用してみてどうですか？</div>
            <div className="answer">
              <span>
                つい最近、車を購入したのですが、それにより大分出し入れが楽になりました。季節の衣類・布団の他にも、使う頻度の低いものを入れています。
              </span>
              <br />
              <span>Ｑ：なにか工夫していることは？</span>
              <br />
              <span>
                ひとつの目安としてですが、トランクルームに入れてそのまま半年間使わなかったものは、処分することに決めています。
              </span>
              <br />
              <span>
                先日、第一回目の処分を行いました。まだ使えそうなものはフリマや寄付で他の方に譲っています。
              </span>
              <br />
              <span>
                エコライフに興味があるので、必要としている人のところへモノが巡回していくのが嬉しくて。
              </span>
              <br />
              <span>
                きちんと生活している実感がもてるので、持ち物にも愛着がわいたように感じています。
              </span>
            </div>
          </div>
          <div className="interview_footer">
            <div className="message">
              <span>maomi_ami様、</span>
              <span>ご協力ありがとうございました。</span>
              <span>※本文章は弊社社員のお客様インタビューを</span>
              <span>再構成し、掲載しております。</span>
            </div>
          </div>
          <Link to="/voice2/voice_case1/" className="btn black">
            その他の活用事例を見る
          </Link>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/voice_case4.jsx